import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import logo from "../images/logo.png";
import { dispDateMonth, getDomain, tempAlWait } from "../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical, faEye, faHeart, faShare } from "@fortawesome/free-solid-svg-icons";
import { likeActu } from "../actions/actus";
import { connect } from "react-redux";

class Article extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        openOpt: false,
        data: {
            codeYtb: '',
            createdAt: null,
            duree: '',
            id: '',
            title: '',
            description: '',
            isLike: false,
            nbLike: 0,
            nbVue: 0
        }
    }

    componentDidMount() {
        this.setState({
            data: this.props.article
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.alert != this.state.alert) {
            this.props.changeAlert(this.state.alert);
        }

        if (prevProps.redLikeActu != this.props.redLikeActu) {
            if (this.props.redLikeActu.isNext) {
                let tempData = this.state.data;
                if (tempData.isLike) {
                    tempData.isLike = false;
                    tempData.nbLike -= 1;
                } else {
                    tempData.isLike = true;
                    tempData.nbLike += 1;
                }
                this.setState({
                    alert: this.props.redLikeActu.alert,
                    data: tempData
                });
            } else {
                this.setState({
                    alert: this.props.redLikeActu.alert
                })
            }
        }
    }

    handleLike = (el) => {
        this.props.likeActu({ actuId: this.state.data.id });
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <article
            className="blog"
            style={
                window.innerWidth > window.innerHeight ? 
                    {backgroundImage: `url('https://img.youtube.com/vi/${this.state.data.codeYtb}/maxresdefault.jpg')`} :
                    {}
                }
        >
            <div className="blog__bg"></div>
            {/** Vidéo **/}
            <iframe width="560" height="315" src={`https://www.youtube.com/embed/${this.state.data.codeYtb}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            {/** Infos vidéos **/}
            <div className="blog__infos">
                <header className="blog__hdr">
                    <Link
                        to="/profil"
                        title={`Accéder au profil de ${this.props.idtt.name}`}
                        aria-label={`Accéder au profil de ${this.props.idtt.name}`}
                        className="blog__linkprof"
                    >
                        <img
                            src={`${getDomain()}image/logo/${this.props.idtt.logo}`}
                            alt={`Logo de ${this.props.idtt.name}`}
                            className="blog__proflogo"
                        />
                    </Link>
                    <span className="blog__hdrname">{this.props.idtt.name}</span>
                    <span className="blog__hdrdate">{dispDateMonth(this.state.data.createdAt?.date)}</span>
                    <span className="blog__hdrtime">{this.state.data.duree} de lecture</span>
                    <div className="blog__hdropts">
                        <button
                            title="Ouvrir les options"
                            aria-label="Ouvrir les options"
                            className="blog__hdrbtnopts"
                            onClick={() => this.setState({openOpt: !this.state.openOpt})}
                        >
                            <FontAwesomeIcon icon={faEllipsisVertical} />
                        </button>
                        <button
                            className={`blog__hdropt ${this.state.openOpt && "blog__hdropt--active"}`}
                            title="Partager le post"
                            aria-label="Partager le post"
                        >
                            <FontAwesomeIcon icon={faShare} />
                            <span className="blog__hdropttxt">Partager le post</span>
                        </button>
                    </div>
                </header>
                <Link to={`/article/${this.state.data.id}`} className="blog__ttl">{this.state.data.title}</Link>
                <p className="blog__desc">{this.state.data.description}</p>
                <footer className="blog__ftr">
                    <div className="blog__ftrview">
                        <FontAwesomeIcon icon={faEye} />
                        <span className="blog__ftrviewnb">{this.state.data.nbVue}</span>
                    </div>
                    <button
                        className={`blog__ftrlike ${this.state.data.isLike && "blog__ftrlike--isLike"}`}
                        onClick={(el) => {this.handleLike(el)}}
                    >
                        <FontAwesomeIcon icon={faHeart} />
                        <span className="blog__ftrlikenb">{this.state.data.nbLike == 0 ? "" : this.state.data.nbLike}</span>
                    </button>
                </footer>
            </div>
        </article>
    }
}

const mapStateToProps = state => {
    return {
        redLikeActu: state.redLikeActu
    }
}

const mapDispatchToProps = {
    likeActu
}

export default connect(mapStateToProps, mapDispatchToProps)(Article);

// todo : vérifier isRead sur les messages user ET admin
